export const FILTER_CHIP_HEIGHT_PX = 24
export const FILTER_CHIP_BORDER_RADIUS_PX = 6
export const FILTER_CHIP_FONT_SIZE_PX = 13
export const FILTER_CHIP_COMMAND_FONT_SIZE_PX = 13
export const FILTER_CHIP_ACCENT = "#0f6170"
export const FILTER_CHIP_COMMAND_COLOR = "#0d6efd"
export const FILTER_CHIP_BORDER = "#ced4da"
export const FILTER_CHIP_LABEL_BG = "#f3f4f6"
export const FILTER_CHIP_COMMAND_BG = "#e9ecef"
export const FILTER_CHIP_COMMAND_FOCUS_BG = "#dde3e8"
export const FILTER_CHIP_DIVIDER = "#ced4da"
export const FILTER_CHIP_TEXT_SECONDARY = "#495057"
export const FILTER_CHIP_TEXT_PRIMARY = "#212529"
export const FILTER_CHIP_SURFACE = "#ffffff"
export const FILTER_CHIP_FOCUS_BG = "rgba(15, 97, 112, 0.08)"
export const FILTER_CHIP_VALUE_MIN_WIDTH_PX = 20
export const FILTER_CHIP_SELECT_CLASS = "v2-filter-chip-select"
export const FILTER_CHIP_SELECT_COMMAND_CLASS = "v2-filter-chip-select-command"
export const FILTER_CHIP_LABEL_PADDING_X_PX = 8
export const FILTER_CHIP_FIELD_PADDING_X_PX = 6
export const FILTER_CHIP_REMOVE_ICON_SIZE_PX = 16
export const FILTER_CHIP_REMOVE_GAP_PX = 4
export const FILTER_CHIP_REMOVE_PADDING_RIGHT_PX = 8
/** Chip height plus 2px focus outline on top and bottom for row alignment */
export const FILTER_CHIP_ROW_HEIGHT_PX = FILTER_CHIP_HEIGHT_PX + 4

const FILTER_CHIP_FIELD_PADDING = `0 ${FILTER_CHIP_FIELD_PADDING_X_PX}px`

const FILTER_CHIP_STYLE_ID = "v2-filter-chip-styles"

const FILTER_CHIP_CSS = `
.v2-filter-chip-select {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
}

.v2-filter-chip-select:focus,
.v2-filter-chip-select:active {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    background-color: ${FILTER_CHIP_FOCUS_BG} !important;
}

.v2-filter-chip-select-command {
    background-color: ${FILTER_CHIP_COMMAND_BG} !important;
}

.v2-filter-chip-select-command:focus,
.v2-filter-chip-select-command:active {
    background-color: ${FILTER_CHIP_COMMAND_FOCUS_BG} !important;
}
`

function ensureFilterChipStyles() {
    if (typeof document === "undefined") {
        return
    }
    if (document.getElementById(FILTER_CHIP_STYLE_ID)) {
        return
    }
    const styleEl = document.createElement("style")
    styleEl.id = FILTER_CHIP_STYLE_ID
    styleEl.textContent = FILTER_CHIP_CSS
    document.head.appendChild(styleEl)
}

ensureFilterChipStyles()

/** @param {boolean} isHighlighted */
export function getFilterChipShellStyle(isHighlighted) {
    return {
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
        height: `${FILTER_CHIP_HEIGHT_PX}px`,
        borderRadius: `${FILTER_CHIP_BORDER_RADIUS_PX}px`,
        border: `1px solid ${FILTER_CHIP_BORDER}`,
        outline: isHighlighted ? `2px solid ${FILTER_CHIP_ACCENT}` : "none",
        outlineOffset: 0,
        overflow: "hidden",
        fontSize: `${FILTER_CHIP_FONT_SIZE_PX}px`,
        background: FILTER_CHIP_SURFACE,
        color: FILTER_CHIP_TEXT_SECONDARY,
        width: "fit-content",
    }
}

export const filterChipLabelStyle = {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    padding: `0 ${FILTER_CHIP_LABEL_PADDING_X_PX}px`,
    background: FILTER_CHIP_LABEL_BG,
    color: FILTER_CHIP_TEXT_SECONDARY,
    fontWeight: 600,
    letterSpacing: "0.01em",
    borderRight: `1px solid ${FILTER_CHIP_DIVIDER}`,
    whiteSpace: "nowrap",
}

const filterChipFieldBaseStyle = {
    display: "block",
    height: `${FILTER_CHIP_HEIGHT_PX}px`,
    margin: 0,
    border: "none",
    borderRadius: 0,
    boxShadow: "none",
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    boxSizing: "border-box",
    backgroundColor: "transparent",
    backgroundImage: "none",
    lineHeight: `${FILTER_CHIP_HEIGHT_PX}px`,
    verticalAlign: "middle",
}

/**
 * @param {HTMLElement | null} element
 * @param {string} text
 * @param {{ fontSize: number, fontWeight?: string | number, padding?: string }} options
 */
export function measureFilterChipTextWidth(element, text, options) {
    if (!element) {
        return 0
    }
    element.style.fontSize = `${options.fontSize}px`
    element.style.fontWeight = String(options.fontWeight ?? 400)
    element.style.padding = options.padding ?? FILTER_CHIP_FIELD_PADDING
    element.style.lineHeight = `${FILTER_CHIP_HEIGHT_PX}px`
    element.textContent = text || " "
    return element.offsetWidth
}

/** @param {number} widthPx */
export function getFilterChipCommandSelectStyle(widthPx) {
    return {
        ...filterChipFieldBaseStyle,
        padding: FILTER_CHIP_FIELD_PADDING,
        fontSize: `${FILTER_CHIP_COMMAND_FONT_SIZE_PX}px`,
        fontWeight: 600,
        backgroundColor: FILTER_CHIP_COMMAND_BG,
        borderRight: `1px solid ${FILTER_CHIP_DIVIDER}`,
        width: `${widthPx}px`,
        minWidth: "20px",
        color: FILTER_CHIP_COMMAND_COLOR,
        textAlign: "center",
        cursor: "pointer",
    }
}

/** @param {number} widthPx */
export function getFilterChipValueSelectStyle(widthPx) {
    return {
        ...filterChipFieldBaseStyle,
        padding: FILTER_CHIP_FIELD_PADDING,
        fontSize: `${FILTER_CHIP_FONT_SIZE_PX}px`,
        fontWeight: 400,
        width: `${widthPx}px`,
        minWidth: "20px",
        color: FILTER_CHIP_TEXT_PRIMARY,
        textAlign: "left",
        cursor: "pointer",
        backgroundColor: FILTER_CHIP_SURFACE,
    }
}

export const filterChipValueInputStyle = {
    ...filterChipFieldBaseStyle,
    padding: FILTER_CHIP_FIELD_PADDING,
    fontSize: `${FILTER_CHIP_FONT_SIZE_PX}px`,
    minWidth: `${FILTER_CHIP_VALUE_MIN_WIDTH_PX}px`,
    color: FILTER_CHIP_TEXT_PRIMARY,
    cursor: "text",
    textAlign: "left",
    backgroundColor: FILTER_CHIP_SURFACE,
}

export const SEARCH_BAR_HEIGHT = "calc(1.5em + 0.75rem + 2px)"

/** @param {HTMLElement | null} element @param {string} command */
export function measureCommandSelectWidth(element, command) {
    const width = measureFilterChipTextWidth(element, command, {
        fontSize: FILTER_CHIP_COMMAND_FONT_SIZE_PX,
        fontWeight: 600,
        padding: FILTER_CHIP_FIELD_PADDING,
    })
    return Math.max(20, width)
}

/** @param {HTMLElement | null} element @param {string} value */
export function measureValueInputWidth(element, value) {
    const width = measureFilterChipTextWidth(element, value, {
        fontSize: FILTER_CHIP_FONT_SIZE_PX,
        padding: FILTER_CHIP_FIELD_PADDING,
    })
    return Math.max(FILTER_CHIP_VALUE_MIN_WIDTH_PX, width)
}

/** @param {HTMLElement | null} element @param {string} displayText */
export function measureValueSelectWidth(element, displayText) {
    const width = measureFilterChipTextWidth(element, displayText, {
        fontSize: FILTER_CHIP_FONT_SIZE_PX,
        padding: FILTER_CHIP_FIELD_PADDING,
    })
    return Math.max(20, width)
}

/** @param {FocusEvent} event */
export function handleFilterChipFieldFocus(event) {
    event.target.style.outline = "none"
    event.target.style.border = "none"
    event.target.style.boxShadow = "none"
}

/** @param {FocusEvent} event */
export function handleFilterChipCommandFocus(event) {
    event.target.style.outline = "none"
    event.target.style.border = "none"
    event.target.style.boxShadow = "none"
    event.target.style.background = FILTER_CHIP_COMMAND_FOCUS_BG
}

/** @param {FocusEvent} event */
export function handleFilterChipCommandBlur(event) {
    event.target.style.background = FILTER_CHIP_COMMAND_BG
}

/** @param {FocusEvent} event */
export function handleFilterChipValueSelectFocus(event) {
    handleFilterChipFieldFocus(event)
    event.target.style.background = FILTER_CHIP_FOCUS_BG
}

/** @param {FocusEvent} event */
export function handleFilterChipValueSelectBlur(event) {
    event.target.style.background = FILTER_CHIP_SURFACE
}

/** @param {FocusEvent} event */
export function handleFilterChipValueInputFocus(event) {
    handleFilterChipFieldFocus(event)
    event.target.style.background = FILTER_CHIP_SURFACE
}

/** @param {FocusEvent} event */
export function handleFilterChipValueInputBlur(event) {
    event.target.style.background = FILTER_CHIP_SURFACE
}
